<!-- Display temporary tabs/search input until view model initializes so we don's see a flash -->
<ng-container *ngIf="showSearchLayoutRedesign && !(vm$ | async)">
  <dgx-search-tabs>
    <div
      class="
        guts-p-h-1-half guts-p-t-3 guts-p-b-2
        m-guts-p-v-1
        l_flexbar l_flex-justify-center
      "
    >
      <div class="l_flex-grow m-no-guts no-phone">
        <dgx-search-initiation-autocomplete
          [showDefaults]="true"
          size="large"
        ></dgx-search-initiation-autocomplete>
      </div>
    </div>
  </dgx-search-tabs>
</ng-container>

<!-- Display full layout after view model initializes -->
<ng-container *ngIf="vm$ | async as vm; else spinner">
  <div [class.dark-mode]="vm.isMarketplaceCat">
    <ng-container *ngIf="!vm.ldFlags.showSearchLayoutRedesign">
      <ng-container *ngTemplateOutlet="searchAndOrgSelector"></ng-container>
    </ng-container>

    <ng-container *ngIf="vm.ldFlags.showSearchLayoutRedesign">
      <dgx-search-tabs [showSearchTabs]="!vm.isMarketplaceCat">
        <ng-container *ngTemplateOutlet="searchAndOrgSelector"></ng-container>
      </dgx-search-tabs>
    </ng-container>

    <ng-container *ngIf="!(hasError$ | async); else searchError">
      <!-- Deprecated Filters -->
      <ng-container *ngIf="!vm.ldFlags.showSearchLayoutRedesign">
        <dgx-search-filters
          dgxSticky
          [stickyCustomClass]="
            'box-shadow guts-p-full-1 bg-color-ebony-a03-hue'
          "
          [notStickyCustomClass]="'guts-m-h-1-half'"
          [isLoading]="vm.isLoading"
          [isClientProvider]="vm.isClientProvider"
          [organizationName]="
            vm.selectedOrganization?.organizationId &&
            vm.selectedOrganization?.name
          "
          [filters]="vm.filters"
          [usesGlobalSearchApi]="true"
          (filtersChange)="vm.updateFilters($event)"
        ></dgx-search-filters>
      </ng-container>

      <div
        *ngIf="
          vm.showFeaturedCarousel && (featuredItems$ | async) as featuredItems
        "
      >
        <dgx-search-featured-carousel
          *ngIf="!featuredItems.showSkeleton"
          [items]="featuredItems.list"
        ></dgx-search-featured-carousel>
        <div
          [class.show]="featuredItems.showSkeleton"
          [class.hide]="!featuredItems.showSkeleton"
          class="carousel-loading"
        >
          <div class="prev-loading-slide bg-animate"></div>
          <div class="current-loading-slide bg-animate"></div>
          <div class="next-loading-slide bg-animate"></div>
        </div>
      </div>

      <div
        class="grid guts-m-t-1-half"
        dgxTrackingArea="Search"
        id="search-results"
      >
        <!-- Filters -->
        <div
          class="no-phone grid__col-xs-4 grid__col-sm-4 grid__col-md-3"
          *ngIf="
            !!vm.transformedSearchFilters && vm.ldFlags.showSearchLayoutRedesign
          "
        >
          <dgx-search-filters-sidebar
            *ngIf="vm.showSearchFiltersSidebar"
            [isLoading]="vm.isLoading"
            [filters]="vm.transformedSearchFilters"
            [showFilterReset]="vm.showFilterReset"
            (filtersChange)="vm.updateFilters($event)"
            (resetFilters)="vm.resetFilters()"
          ></dgx-search-filters-sidebar>
        </div>

        <div
          [ngClass]="{
            'grid__col-xs-8 grid__col-sm-8 grid__col-md-9':
              vm.ldFlags.showSearchLayoutRedesign ||
              !vm.ldFlags.showSearchLayoutRedesign,
            'grid__col-xs-12 grid__col-sm-12 grid__col-md-12':
              vm.ldFlags.showSearchLayoutRedesign
          }"
        >
          <!-- Related Skills -->
          <ng-container *ngIf="vm.ldFlags.showSearchLayoutRedesign">
            <ng-container *ngTemplateOutlet="relatedSkills"></ng-container>
          </ng-container>

          <!-- Typo suggest -->
          <ng-container *ngIf="vm.showTypoSuggestion">
            <dgx-search-typo-suggestion
              class="guts-m-b-2"
              [searchTerm]="vm.term"
              [suggestedTerm]="vm.suggestedTerm"
              [previousSearchTerm]="vm.previousTerm"
              [typoSuggestionAutoSearched]="vm.typoAutoSearched"
              (suggestionSelected)="vm.updateTerm($event)"
            ></dgx-search-typo-suggestion>
          </ng-container>

          <ng-container
            *ngIf="vm.showPrioritizedEndorsedContent; else searchLearnings"
          >
            <ng-container [ngSwitch]="showEndorsedContent$ | async">
              <!-- We're showing separate endorsed content section, show it before regular results -->
              <ng-container *ngSwitchCase="true">
                <ng-container
                  *ngIf="
                    !vm.isMarketplaceCat && endorsedSearch$ | async as endorsed
                  "
                >
                  <!-- `Endorsed` header & sort dropdown -->
                  <dgx-search-results-header
                    [isLoading]="vm.isLoading"
                    [headerText]="vm.i18n.Core_Endorsed"
                    [totalContentResults]="vm.pagination.total"
                    [pageNum]="vm.pagination.currentPage"
                    [sortBy]="vm.sort"
                    [hideCount]="true"
                    (sortChange)="vm.updateSortBy($event)"
                  ></dgx-search-results-header>

                  <!-- Endorse results list -->
                  <dgx-search-endorsed-results
                    [results]="endorsed.list"
                    [isLoading]="endorsed.isLoading"
                    [mayLoadEndorsedContent]="mayLoadEndorsedContent$ | async"
                    (loadEndorsedContent)="vm.loadEndorsedContent()"
                  ></dgx-search-endorsed-results>
                </ng-container>

                <div class="l_flex l_flex-bottom-children l_flex-justify">
                  <!-- `Results #-20 of ####` header -->
                  <dgx-search-results-header
                    [isLoading]="vm.isLoading"
                    [headerText]="vm.i18n.Core_Results"
                    [totalContentResults]="vm.pagination.total"
                    [pageNum]="vm.pagination.currentPage"
                    [hideSort]="true"
                    (sortChange)="vm.updateSortBy($event)"
                  ></dgx-search-results-header>
                </div>
              </ng-container>

              <!-- No separate endorsed content section. Just show regular results -->
              <ng-container *ngSwitchCase="false">
                <!-- `Results #-20 of ####` header & sort dropdown -->
                <dgx-search-results-header
                  [isLoading]="vm.isLoading"
                  [headerText]="
                    !vm.endorsedFilterSelected
                      ? vm.i18n.Core_Results
                      : vm.i18n.Core_Endorsed
                  "
                  [totalContentResults]="vm.pagination.total"
                  [pageNum]="vm.pagination.currentPage"
                  [sortBy]="vm.sort"
                  (sortChange)="vm.updateSortBy($event)"
                  [hideSort]="vm.isMarketplaceCat"
                ></dgx-search-results-header>
              </ng-container>
            </ng-container>

            <!-- Search results -->
            <dgx-search-results
              *ngIf="!(hasError$ | async)"
              [isLoading]="vm.isLoading"
              [results]="vm.results"
              [totalContentResults]="vm.pagination.total"
              [searchTerm]="vm.term"
              [pageNum]="vm.pagination.currentPage"
              [trackingLocation]="vm.trackingLocation"
              [onClickTrackingEvent]="'contentOpened'"
            ></dgx-search-results>

            <!-- No results / API error -->
            <dgx-search-no-results
              *ngIf="vm.showNoResults"
              [filters]="vm.filters"
              [searchTerm]="vm.term"
            ></dgx-search-no-results>

            <!-- Pagination -->
            <dgx-search-results-pagination
              [pageNum]="vm.pagination.currentPage"
              [totalContentResults]="vm.pagination.total"
              (pageChange)="vm.pagination.showPage($event)"
            ></dgx-search-results-pagination>
          </ng-container>
        </div>

        <!-- Side Bar -->
        <div
          *ngIf="!vm.ldFlags.showSearchLayoutRedesign"
          class="grid__col-xs-3 grid__col-sm-3 grid__col-md-3 guts-p-t-5"
        >
          <!-- Opportunities -->
          <dgx-search-opportunities
            *ngIf="
              !vm.isMarketplaceCat &&
              vm.canViewOpportunities &&
              (opportunities$ | async) as opportunities
            "
            [isLoading]="!opportunities.isReady"
            [items]="opportunities.list"
            [totalNumItems]="opportunities.totalCount"
            [searchTerm]="vm.term"
          >
          </dgx-search-opportunities>
          <!-- Skills -->
          <dgx-search-skills
            *ngIf="!vm.isMarketplaceCat && skills$ | async as skills"
            [items]="skills.list"
            [totalNumItems]="skills.totalCount"
            [isLoading]="!skills.isReady"
            [searchTerm]="vm.term"
          ></dgx-search-skills>
          <!-- People -->
          <dgx-search-people
            *ngIf="!vm.isMarketplaceCat && people$ | async as people"
            [items]="people.list"
            [totalNumItems]="people.totalCount"
            [isLoading]="!people.isReady"
            [searchTerm]="vm.term"
          ></dgx-search-people>
          <!-- Groups -->
          <dgx-search-groups
            *ngIf="!vm.isMarketplaceCat && groups$ | async as groups"
            [items]="groups.list"
            [totalNumItems]="groups.totalCount"
            [isLoading]="!groups.isReady"
            [searchTerm]="vm.term"
          ></dgx-search-groups>
        </div>
      </div>
    </ng-container>

    <dgx-footer-glasses [hidden]="vm.isLoading"></dgx-footer-glasses>

    <!-- Mobile Filters -->
    <dgx-search-mobile-filters
      class="phone-only"
      *ngIf="vm.ldFlags.showSearchLayoutRedesign && vm.isPhone"
      [isLoading]="vm.isLoading"
      [filters]="vm.transformedSearchFilters"
      [showFilterReset]="vm.showFilterReset"
      (filtersChange)="vm.updateFilters($event)"
      (resetFilters)="vm.resetFilters()"
    ></dgx-search-mobile-filters>

    <!-- Search / Org Selector template -->
    <ng-template #searchAndOrgSelector>
      <!-- Skip navigation -->
      <dgx-skip-nav
        containerName="search-results"
        [linkText]="vm.i18n.dgSkipNav_SkipToSearchResults"
      ></dgx-skip-nav>
      <div
        class="l_flex guts-p-h-1-half guts-p-t-3 guts-p-b-2 m-guts-p-v-1"
        [ngClass]="{
          'l_flex-justify-center': !vm.isPhone,
          'm-l_flex l_flex-column': vm.isPhone
        }"
      >
        <div
          class="l_flex-grow"
          [ngClass]="{ 'guts-p-b-1': vm.isMobile, 'guts-m-r-2': !vm.isMobile }"
        >
          <!-- Search Field -->
          <dgx-search-initiation-autocomplete
            *ngIf="vm.ldFlags.showSearchInitiationAutocomplete"
            size="large"
            (inputEnter)="vm.updateTerm($event)"
            [searchTerm]="vm.term"
            [termSuggestionsOnly]="true"
            [showDefaults]="true"
            [initiationLocation]="vm.searchInitiationLocation"
          ></dgx-search-initiation-autocomplete>
          <!-- Deprecated Search Field-->
          <dgx-simple-search-suggest
            *ngIf="!vm.ldFlags.showSearchInitiationAutocomplete"
            (inputEnter)="vm.updateTerm($event)"
            [searchTerm]="vm.term"
            [showDefaults]="true"
          ></dgx-simple-search-suggest>
          <!-- Deprecated Related Skills -->
          <ng-container *ngIf="!vm.ldFlags.showSearchLayoutRedesign">
            <div [ngClass]="{ 'guts-p-b-1': vm.isMobile }">
              <ng-container *ngTemplateOutlet="relatedSkills"></ng-container>
            </div>
          </ng-container>
        </div>
        <!-- Org Selector -->
        <ng-container *ngIf="vm.showOrgSelector">
          <dgx-org-selector
            [ngClass]="{ 'l_flex-center full-width': vm.isPhone }"
            [defaultOrgId]="vm.defaultOrgId"
            [orgs]="vm.organizations"
            [selectedOrg]="vm.selectedOrganization"
            (selectedOrgChange)="vm.updateOrganization($event)"
            [showMarketplace]="vm.isMarketplaceEnabled"
            [isLoading]="vm.isLoading"
          ></dgx-org-selector>
        </ng-container>
      </div>
    </ng-template>

    <!-- Related skills template -->
    <ng-template #relatedSkills>
      <dgx-search-related-skills
        *ngIf="!vm.isMarketplaceCat && relatedSkills$ | async as relatedSkills"
        [isLoading]="!relatedSkills.isReady"
        [skills]="relatedSkills.list"
        (skillSelected)="vm.updateTerm($event)"
      ></dgx-search-related-skills>
    </ng-template>

    <!-- Deprecated search results list template-->
    <ng-template #searchLearnings>
      <dgx-search-learnings
        [isLoading]="vm.isLoading"
        [results]="vm.results"
        [totalContentResults]="vm.pagination.total"
        [searchTerm]="vm.term"
        [pageNum]="vm.pagination.currentPage"
        (pageChange)="vm.pagination.showPage($event)"
        (sortChange)="vm.updateSortBy($event)"
      ></dgx-search-learnings>
    </ng-template>

    <ng-template #searchError>
      <div class="guts-m-t-6">
        <dgx-search-no-results
          [searchTerm]="vm.term"
          [hasError]="true"
        ></dgx-search-no-results>
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-template #spinner>
  <div class="guts-p-t-5">
    <df-spinner [isSpinning]="true"></df-spinner>
  </div>
</ng-template>
